import React from 'react';
import VividhView from '../components/vividh/VividhView';

function VividhPage({ allNews, onOpen }) {
  const newsArray = Array.isArray(allNews) ? allNews : [];

  return (
    <VividhView
      allNews={newsArray}
      onOpen={onOpen}
    />
  );
}

export default VividhPage;